import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { formValueSelector } from "redux-form"
import BackgroundTab from "./backgroundTab"
import BrandImageTab from "./brandImageTab"
import BrandingTab from "./brandingTab"
import ThumbnailPreview from "./thumbnailPreview"
import ThumbnailTab from "./thumbnailTab"

const DesignTab = ({
  tabIsActive,
  handleNext,
  handleSave,
  listScreenSetup,
  thumbnailImage,
  bgImage,
  setSubTabBreadcrumb,
}) => {
  const TABS = {
    BRANDING: 1,
    BACKGROUND: 2,
    BRAND_IMAGE: 3,
    THUMBNAIL: 4,
  }
  const [activeTab, setActiveTab] = useState(TABS.BRANDING)
  const [previewToggle, setPreviewToggle] = useState(true)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (tabIsActive) {
      setActiveTab(TABS.BRANDING)
      setSubTabBreadcrumb("Branding", () => {
        setActiveTab(TABS.BRANDING)
      })
    }
  }, [tabIsActive])

  useEffect(() => {
    let tabTitle = ""
    switch (activeTab) {
      case 1:
        tabTitle = "Branding"
        break
      case 2:
        tabTitle = "Background"
        break
      case 3:
        tabTitle = "Brand Image & Logo"
        break
      case 4:
        tabTitle = "Thumbnail"
        break
      default:
        break
    }
    setSubTabBreadcrumb(tabTitle, () => {
      setActiveTab(TABS.BRANDING)
    })
  }, [activeTab])

  return (
    <React.Fragment>
      <Row>
        <Col xl={8}>
          <Row className="my-3">
            <Col xs="auto ms-5">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    className={markIfIsActive(TABS.BRANDING)}
                    onClick={() => setActiveTab(TABS.BRANDING)}
                    style={
                      activeTab === TABS.BRANDING
                        ? {}
                        : { backgroundColor: "#eff2f7" }
                    }
                  >
                    <span style={{ fontSize: "16px" }}>Branding</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={markIfIsActive(TABS.BACKGROUND)}
                    onClick={() => setActiveTab(TABS.BACKGROUND)}
                    style={
                      activeTab === TABS.BACKGROUND
                        ? {}
                        : { backgroundColor: "#eff2f7" }
                    }
                  >
                    <span style={{ fontSize: "16px" }}>Background</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={markIfIsActive(TABS.BRAND_IMAGE)}
                    onClick={() => setActiveTab(TABS.BRAND_IMAGE)}
                    style={
                      activeTab === TABS.BRAND_IMAGE
                        ? {}
                        : { backgroundColor: "#eff2f7" }
                    }
                  >
                    <span style={{ fontSize: "16px" }}>Brand Image/Logo</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={markIfIsActive(TABS.THUMBNAIL)}
                    onClick={() => setActiveTab(TABS.THUMBNAIL)}
                    style={
                      activeTab === TABS.THUMBNAIL
                        ? {}
                        : { backgroundColor: "#eff2f7" }
                    }
                  >
                    <span style={{ fontSize: "16px" }}>Thumbnail</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col>
              <TabContent
                activeTab={activeTab}
                className="text-muted mt-4 mt-md-0"
              >
                <TabPane style={{ animation: "none" }} tabId={TABS.BRANDING}>
                  <BrandingTab
                    tabIsActive={tabIsActive && activeTab === TABS.BRANDING}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleNext={() => setActiveTab(TABS.BACKGROUND)}
                    handleSave={handleSave}
                  />
                </TabPane>
                <TabPane style={{ animation: "none" }} tabId={TABS.BACKGROUND}>
                  <BackgroundTab
                    tabIsActive={tabIsActive && activeTab === TABS.BACKGROUND}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.BRANDING)}
                    handleNext={() => setActiveTab(TABS.BRAND_IMAGE)}
                    handleSave={handleSave}
                  />
                </TabPane>
                <TabPane style={{ animation: "none" }} tabId={TABS.BRAND_IMAGE}>
                  <BrandImageTab
                    tabIsActive={tabIsActive && activeTab === TABS.BRAND_IMAGE}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.BACKGROUND)}
                    handleNext={() => setActiveTab(TABS.THUMBNAIL)}
                    handleSave={handleSave}
                  />
                </TabPane>
                <TabPane style={{ animation: "none" }} tabId={TABS.THUMBNAIL}>
                  <ThumbnailTab
                    tabIsActive={tabIsActive && activeTab === TABS.THUMBNAIL}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.BRAND_IMAGE)}
                    handleNext={handleNext}
                    handleSave={handleSave}
                  />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <Row>
            <p style={{ textAlign: "center", margin: "0px" }}>
              <b>
                {previewToggle ? "App Background Preview" : "Thumbnail Preview"}
              </b>
            </p>
          </Row>
          <Row xs="auto" className="d-flex justify-content-center my-2">
            <SaveButton
              type="button"
              content="Toggle Screens"
              onClick={() => setPreviewToggle(!previewToggle)}
            />
          </Row>
          {previewToggle ? (
            <PhoneArea>
              <div
                style={{
                  backgroundColor: "gray",
                  backgroundImage: `url(${bgImage?.editedImage})`,
                  width: "108%",
                  height: "105%",
                  backgroundSize: "cover",
                  marginLeft: "-10px",
                  backgroundPosition: "center center",
                }}
              />
            </PhoneArea>
          ) : (
            <ThumbnailPreview
              bgImage={{
                editedImage: listScreenSetup?.bg_image_url,
              }}
              layout={listScreenSetup?.template_id.toString()}
              bgColor={listScreenSetup?.bg_color}
              headerColor={listScreenSetup?.header_tab_color}
              headerImage={{ editedImage: listScreenSetup?.image_url }}
              title={listScreenSetup?.my_events_text}
              textColor={listScreenSetup?.header_text_color}
              textFont={listScreenSetup?.header_font}
              data={[
                {
                  name: "Experience 1",
                  img: thumbnailImage?.editedImage,
                  boxShadow: "inset 0 0 0 100px rgb(0 0 0 / 40%)",
                  image: { url: thumbnailImage?.editedImage },
                },
              ]}
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  listScreenSetup: state.ListScreen.listScreenSetup,
  thumbnailImage: selector(state, "design.thumbnailImage"),
  bgImage: selector(state, "design.bgImage"),
})

export default connect(mapStateToProps)(DesignTab)
